module.exports = __webpack_public_path__ + "img/compass.11dc64a5.svg";